export default __webpack_public_path__ + "99eb915062da85d8aa636533bcceae88.svg";